// Экран сущности с ключом по параметру маршрута (HQ-1398): переход матч → матч (H2H, форма) или команда → команда
// (таблица) идёт в тот же маршрут, и без ключа react-router оставляет экран смонтированным — вкладка, прокрутка и
// прочее состояние прошлой сущности переезжали на новую. С ключом экран монтируется заново: вкладка по умолчанию,
// content_open — один раз на показ новой сущности (useContentOpen нового экземпляра). Окно — общий скроллер, его
// ключ не сбрасывает: при смене id обёртка (она сама не перемонтируется) поднимает прокрутку наверх.
import { Fragment, useLayoutEffect, useRef, type ReactNode } from 'react';
import { useParams, type Params } from 'react-router-dom';

/** Ключ экрана: значение параметра маршрута (нет параметра — пусто). */
export function routeKey(params: Params, param = 'id'): string {
  return params[param] ?? '';
}

export function KeyedRoute({ children, param = 'id' }: { children: ReactNode; param?: string }) {
  const key = routeKey(useParams(), param);
  const shown = useRef(key);
  useLayoutEffect(() => {
    if (shown.current === key) return;
    shown.current = key;
    window.scrollTo(0, 0);
  }, [key]);
  return <Fragment key={key}>{children}</Fragment>;
}
